document.addEventListener('DOMContentLoaded', () => {
	let openBtns = document.querySelectorAll('[data-trigger="contact-popup"]')
	const modal = document.querySelector('[data-modal="contact-popup"]')
	const closeBtn = modal?.querySelector('[aria-label="close"]')

	openBtns.forEach(openBtn => {
		openBtn.addEventListener('click', () => {
			modal?.classList.add('active')
		})
	})

	closeBtn?.addEventListener('click', () => {
		modal?.classList.remove('active')
	})

	// Click-off functionality
	window.addEventListener('click', e => {
		if (
			e.target.closest('[data-modal="contact-popup"]') &&
			!e.target.closest('[data-modal="contact-popup"] .card')
		) {
			modal?.classList.remove('active')
		}
	})

	// When the search results page DOM changes, we need to update the openBtns nodelist
	const targetNode = document.getElementById("results");
	const config = { attributes: false, childList: true, subtree: false };
	const callback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === "childList") {
				openBtns = document.querySelectorAll('[data-trigger="contact-popup"]')
				openBtns.forEach(openBtn => {
					openBtn.addEventListener('click', () => {
						modal?.classList.add('active')
					})
				})
			}
		}
	};
	const observer = new MutationObserver(callback);
	if (targetNode) {
		observer.observe(targetNode, config);
	}
})
